import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["id", "options", "variant", "label", "name", "onChange", "onBlur", "getOptionLabel", "type", "leftIcon", "defaultValue", "inputProps", "error", "helperText"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Autocomplete as MuiAutocomplete } from '@mui/material';
import { makeStyles } from '@mui/styles';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '../../atoms/TextField';
import CitiesAutocomplete from './Cities';
import Image from '../../atoms/Image';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var useClasses = makeStyles({
  LeftIconStyle: {
    borderRadius: '50%'
  }
});
var Autocomplete = function Autocomplete(_ref) {
  var id = _ref.id,
    options = _ref.options,
    variant = _ref.variant,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    getOptionLabel = _ref.getOptionLabel,
    type = _ref.type,
    leftIcon = _ref.leftIcon,
    defaultValue = _ref.defaultValue,
    inputProps = _ref.inputProps,
    error = _ref.error,
    helperText = _ref.helperText,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses();
  if (type === 'cities') {
    return /*#__PURE__*/_jsx(CitiesAutocomplete, _objectSpread({
      id: id,
      label: label,
      getOptionLabel: getOptionLabel,
      variant: variant,
      onChange: onChange,
      defaultValue: defaultValue,
      error: error,
      helperText: helperText
    }, props));
  }
  return /*#__PURE__*/_jsx(MuiAutocomplete, _objectSpread({
    id: id
    // className={classes.}
    ,
    options: options,
    defaultValue: defaultValue,
    getOptionLabel: getOptionLabel
    // style={{ width: 300 }}
    ,
    onChange: onChange,
    onBlur: onBlur,
    renderInput: function renderInput(params) {
      if (leftIcon) {
        // eslint-disable-next-line no-param-reassign

        // eslint-disable-next-line no-param-reassign
        params.InputProps.startAdornment = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(InputAdornment, {
            position: "start",
            children: typeof leftIcon === 'object' ? leftIcon : /*#__PURE__*/_jsx(Image, {
              width: "24px",
              height: "24px",
              src: leftIcon,
              alt: "logo",
              className: classes.LeftIconStyle
            })
          }), params.InputProps.startAdornment]
        });
      }
      return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread(_objectSpread({}, inputProps), {}, {
        error: error,
        name: name,
        helperText: helperText,
        onBlur: onBlur
      }, params), {}, {
        label: label,
        variant: variant,
        fullWidth: true,
        autoComplete: "off"
      }));
    }
    // autoComplete={false}
  }, props));
};
Autocomplete.defaultProps = {
  getOptionLabel: function getOptionLabel(option) {
    return option && option.name;
  },
  onChange: function onChange() {},
  type: null,
  id: null,
  options: [],
  label: '',
  variant: undefined,
  error: false,
  helperText: undefined,
  leftIcon: null,
  name: '',
  onBlur: function onBlur() {},
  defaultValue: {}
};
export default Autocomplete;